<template>
  <van-dialog v-model="showProcess" title="流程信息" @confirm="handleSubmit()" show-cancel-button>
    <van-cell-group v-if="isFinish">
      <van-cell title="下一步活动" value="流程审批结束"/>
    </van-cell-group>
    <van-cell-group v-else>
      <van-cell title="下一步活动" :value="showTableData[0].taskName"/>
      <van-cell title="处理部门" :value="showTableData[0].orgName"/>
      <van-cell title="处理人员" :value="showTableData[0].taskUserName"/>
    </van-cell-group>
  </van-dialog>
</template>

<script>

import {Toast} from "vant";
import {bodyPost} from "../utils/http";

export default {
  data() {
    return {
      showTableData: [],
      isFinish: false,
      showProcess: false,
    }
  },
  props: {
    getFlowParamsMethod: Function,
    submitFlowMethod: Function,
  },
  created() {

  },
  methods: {
    showProcessInfo() {
      this.showProcess = true;
      let params = {};
      //调用父组件获取参数
      //再调用公共接口查询下一步待办情况
      if (typeof this.getFlowParamsMethod === 'function') {
        params = this.getFlowParamsMethod();
      } else {
        Toast("缺少流程参数");
        return;
      }
      this.$bodyPost("/attence-api/blade-flow/process/getTaskNextHandlerBeforeSend", params).then(res => {
        const data = res.data;
        if (data.length == 0) {
          this.isFinish = true;
        } else {
          this.isFinish = false;
          this.showTableData = data;
        }
      });
    },
    handleSubmit() {
      if (typeof this.submitFlowMethod === 'function') {
        this.submitFlowMethod();
      } else {
        Toast("缺少提交方法");
        return;
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProcessDialog.vue